import { useTranslation } from 'react-i18next';
import { PageMeta } from '../components/PageMeta';

type StepItem = {
  title: string;
  body: string;
};

type ClarificationItem = {
  title: string;
  body: string;
};

export function PhonePaymentsPage() {
  const { t } = useTranslation();
  const intro = t('phonePaymentsPage.intro', { returnObjects: true }) as string[];
  const steps = t('phonePaymentsPage.steps', { returnObjects: true }) as StepItem[];
  const clarifications = t('phonePaymentsPage.clarifications', {
    returnObjects: true,
  }) as ClarificationItem[];
  const closing = t('phonePaymentsPage.closing', { returnObjects: true }) as string[];

  return (
    <>
      <PageMeta
        titleKey="phonePaymentsPage.metaTitle"
        descriptionKey="phonePaymentsPage.metaDescription"
      />

      <section className="section-band section-band--dark-mid about-hero">
        <div className="about-hero-inner">
          <p className="about-eyebrow">{t('phonePaymentsPage.eyebrow')}</p>
          <h1>{t('phonePaymentsPage.title')}</h1>
          <p className="about-tagline">{t('phonePaymentsPage.tagline')}</p>
        </div>
      </section>

      <section className="about-section" aria-labelledby="phone-payments-intro-heading">
        <div className="about-section-inner">
          <h2 id="phone-payments-intro-heading">{t('phonePaymentsPage.introHeading')}</h2>
          {intro.map((paragraph) => (
            <p key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
        </div>
      </section>

      <section
        className="about-section about-section--alt"
        aria-labelledby="phone-payments-steps-heading"
      >
        <div className="about-section-inner about-section-inner--wide">
          <h2 id="phone-payments-steps-heading">{t('phonePaymentsPage.stepsHeading')}</h2>
          <ol className="payment-steps">
            {steps.map((step, index) => (
              <li key={step.title} className="payment-step">
                <span className="payment-step-number" aria-hidden="true">
                  {index + 1}
                </span>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.body}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>

      <section className="about-section" aria-labelledby="phone-payments-clarify-heading">
        <div className="about-section-inner about-section-inner--wide">
          <h2 id="phone-payments-clarify-heading">
            {t('phonePaymentsPage.clarificationsHeading')}
          </h2>
          <ul className="values-grid">
            {clarifications.map((item) => (
              <li key={item.title} className="value-card">
                <h3>{item.title}</h3>
                <p>{item.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section
        className="about-section about-section--alt"
        aria-labelledby="phone-payments-closing-heading"
      >
        <div className="about-section-inner">
          <h2 id="phone-payments-closing-heading">{t('phonePaymentsPage.closingHeading')}</h2>
          {closing.map((paragraph) => (
            <p key={paragraph.slice(0, 48)}>{paragraph}</p>
          ))}
        </div>
      </section>
    </>
  );
}
